<template>
  <div>
    <SearchFilters
      :searchQuery="searchQuery"
      :showSearchBox="showSearchBox"
      @businessChange="handleBusinessChange"
      :showBranchSelector="false"
      @update:searchQuery="searchQuery = $event"
    />
    <b-container fluid>
      <b-row class="mb-3">
        <b-col cols="12" md="8" class=" ">
          <div class="iq-card ">
            <div class="iq-card-header ">
              <div class="iq-header-title">
                <h4 class="card-title">Categories List</h4>
              </div>
            </div>

            <div class="iq-card-body">
              <b-overlay :show="loading" rounded="sm" variant="Primary"></b-overlay>
              <b-table
                class="table b-table table-striped"
                :items="filteredLocalizedItems"
                :fields="columns.map(col => col.prop)"
                striped
                ref="table"
              >
                <template v-for="column in columns" #[`cell(${column.prop})`]="data" >
                  <div v-if="!column.isAction">
                    <div
                      class="user-img img-fluid"
                      v-if="
                        column.isImage &&
                          Array.isArray(data.item[column.prop]) &&
                          data.item[column.prop].length
                      "
                    >
                      <b-img
                        :src="data.item[column.prop][0].src"
                        alt="business logo"
                        rounded
                        class=" rounded-circle avatar-70 "
                      />
                    </div>

                    <span v-else>{{
                      data.item[column.prop] || column.default
                    }}</span>
                  </div>

                  <span v-else>
                    <b-button @click="editMenu(data.item)" variant=" iq-bg-success mr-1 " size="sm" >
                      <i class="ri-ball-pen-fill"></i>
                    </b-button>
                    <b-button @click="handleDelete(data.item)" v-b-modal.modal-delete variant=" iq-bg-danger" size="sm" >
                      <i class="ri-delete-bin-line"></i>
                    </b-button>
                  </span>
                </template>
              </b-table>
              <div class="mt-3 d-flex justify-content-center"v-if="!this.searchQuery" >
                <b-pagination
                  class="iq-page-primary"
                  v-if="paginationMeta.total > paginationMeta.per_page"
                  v-model="paginationMeta.current_page"
                  :total-rows="paginationMeta.total"
                  :per-page="paginationMeta.per_page"
                  @input="fetchCategoriesList"
                />
              </div>
              <EmptySearchMessage
                v-if="searchQuery && filteredLocalizedItems.length <= 0"
              />
            </div>
          </div>
        </b-col>
        <b-col cols="6" md="4" class="">
          <div class="iq-card ">
            <Create
              v-if="showAdd"
              :isInList="true"
              @onSubmit="fetchCategoriesList()"
              :businessId="businessId"
            />

            <Edit
              v-if="!showAdd && editModel"
              :isInList="true"
              @onSubmit="fetchCategoriesList()"
              :model="editModel"
              :showAdd="showAdd"
              @showAddChanged="updateShowAddState"
              :businessId="businessId"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>

    <!-- this modal will be shown after clicking the delete button -->
    <b-modal
      id="modal-delete"
      title="Confirm Delete"
      @ok="confirmDelete"
      ok-title="Yes, Delete"
      cancel-title="Cancel"
      ok-variant="danger"
      centered
    >
      <p>Are you sure you want to delete this item?</p>
    </b-modal>
    <!-- end of modal -->
  </div>
</template>

<script>
import Create from "./Create.vue";
import TableConfiguration from "./TableConfiguration";
import Edit from "./Edit.vue";
import { core } from "@/config/pluginInit";
import SearchFilters from "@/components/SearchFilters.vue";
import EmptySearchMessage from "@/components/EmptySearchMessage.vue";
import { deleteCategory, getCategoriesList } from "@/API/CategoriesAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "CategoriesList",
  mixins: [TableConfiguration],
  components: {
    Create,
    Edit,
    SearchFilters,
    EmptySearchMessage
  },
  data() {
    return {
      loading: false,
      items: [],
      searchQuery: "",
      businessId: null,
      showAdd: true,
      editModel: null,
      deletedItem: null,
      showSearchBox: true
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    filteredLocalizedItems() {
      return this.items
        .map(item => {
          const localizedData =
            item.locales.find(locale => locale.locale === this.currentLocale) ||
            item.locales[0];
          return {
            ...item,
            name: localizedData?.name || "",
            description: localizedData?.description || ""
          };
        })
        .filter(item =>
          item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    },
    userBusinesses() {
      return this.$store.state.User.user.business || [];
    }
  },
  watch: {
    userBusinesses: {
      handler(newBusinesses) {
        if (newBusinesses.length > 0 && !this.businessId) {
          this.businessId = newBusinesses[0].id;
          this.fetchCategoriesList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    core.index();
  },
  methods: {
    handleBusinessChange(newValue) {
        this.businessId = newValue;
        this.fetchCategoriesList();
    },
    handleDelete(model) {
      this.deletedItem = model;
    },
    confirmDelete() {
      if (this.deletedItem) {
        const callback = () => {
          this.fetchCategoriesList();
        };
        submitAndNotify(this, deleteCategory(this.deletedItem.id), callback);
      }
    },
    async fetchCategoriesList(page = 1) {
      if (!this.businessId) return;
      this.loading = true;
      try {
        const perPage = this.searchQuery
          ? this.paginationMeta.total
          : this.paginationMeta.per_page;
        const response = await getCategoriesList({ "per-page": perPage, page });
        this.items = response.data;
        this.paginationMeta = response.meta;
      } catch (error) {
        console.error(error);
        this.items = [];
      }finally{
        this.loading = false;
      }
    },
    editMenu(model) {
      this.showAdd = false;
      const requiredLocales = ["en", "ar"];
      this.editModel = {
        ...model,
        locales: requiredLocales.map(
          locale =>
            model.locales.find(l => l.locale === locale) || {
              locale,
              name: "",
              description: "",
              id: ""
            }
        )
      };
    },
    updateShowAddState(newValue) {
      this.showAdd = newValue;
    }
  }
};
</script>

<style scoped></style>
